import type { ChatTurn, QuestionView } from "./assistant-types";

/** How a settled Question shows: answered with its Answer and vote, or failed with the Caller-facing reason. */
export function settledFields(
  view: QuestionView,
): Pick<ChatTurn, "status" | "answer" | "error" | "questionId" | "vote"> {
  return {
    status: view.answer === null ? "failed" : "answered",
    answer: view.answer ?? undefined,
    error: view.answer === null ? (view.error ?? `Question ${view.status}`) : undefined,
    questionId: view.questionId,
    vote: view.vote ?? undefined,
  };
}

/** The turns of a resumed Conversation, in asking order. */
export function turnsFromViews(views: readonly QuestionView[]): ChatTurn[] {
  return views.map((view) => ({
    id: view.questionId,
    question: view.text,
    imageCount: view.imageCount,
    ...settledFields(view),
  }));
}
